"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BaseStorageProvider2 = _interopRequireDefault(require("./BaseStorageProvider"));

var _clientErrorLogger = _interopRequireDefault(require("../../../util/clientErrorLogger"));

var _urlUtilities = require("../../../util/urlUtilities");

var _chainedRequest = _interopRequireDefault(require("../../../util/chainedRequest"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FormApiStorageProvider = /*#__PURE__*/function (_BaseStorageProvider) {
  _inherits(FormApiStorageProvider, _BaseStorageProvider);

  var _super = _createSuper(FormApiStorageProvider);

  function FormApiStorageProvider(endpoint, deleteEndpoint, formErrorCallback, customSpinnerEvent) {
    var _this;

    _classCallCheck(this, FormApiStorageProvider);

    _this = _super.call(this);
    _this.formErrorCallback = formErrorCallback;
    _this.endpoint = endpoint || "";
    _this.deleteEndpoint = deleteEndpoint || "";
    _this.deleteEndpointQueryStringArgs = {};
    _this.customSpinnerEvent = customSpinnerEvent || null;
    return _this;
  }

  _createClass(FormApiStorageProvider, [{
    key: "_save",
    value: function _save(dispatcher, data, callback, errorCallback) {
      var _this2 = this;

      if ((0, _isEmpty.default)(this.endpoint)) {
        _get(_getPrototypeOf(FormApiStorageProvider.prototype), "save", this).call(this, dispatcher, data, callback);

        return;
      }

      (0, _chainedRequest.default)(dispatcher).withLoadSpinner(this.customSpinnerEvent).post(this.endpoint).set("Content-Type", "application/json").accept("json").send(data).respond().onFormError(null, function (err, res, next) {
        // eslint-disable-line handle-callback-err
        if ((0, _isFunction.default)(_this2.formErrorCallback)) {
          return _this2.formErrorCallback(res.body.errors);
        } else {
          return next();
        }
      }).onError(function (err, res) {
        var _err$response;

        dispatcher.emit("SHOW_FLASH_MESSAGE", {
          message: "We're having trouble with your request. Please contact Customer Service.",
          className: "error"
        });

        if (err !== null && err !== void 0 && (_err$response = err.response) !== null && _err$response !== void 0 && _err$response.text) {
          var responseObj = JSON.parse(err.response.text);
          var message = responseObj.message || "Error";
          var modelState = responseObj.modelState || "Empty Model State";

          _clientErrorLogger.default.notify(message, "error", modelState);
        }
      }).onRedirect().handle(callback);
    }
  }, {
    key: "_delete",
    value: function _delete(dispatcher, callback) {
      var _this3 = this;

      if ((0, _isEmpty.default)(this.deleteEndpoint)) {
        _get(_getPrototypeOf(FormApiStorageProvider.prototype), "delete", this).call(this, dispatcher, callback);

        return;
      }

      (0, _chainedRequest.default)(dispatcher).withLoadSpinner(this.customSpinnerEvent).del((0, _urlUtilities.appendQueryParams)(this.deleteEndpoint, this.deleteEndpointQueryStringArgs)).respond().onFormError(null, function (err, res, next) {
        // eslint-disable-line handle-callback-err
        if ((0, _isFunction.default)(_this3.formErrorCallback)) {
          return _this3.formErrorCallback(res.body.errors);
        } else {
          return next();
        }
      }).onError(function (err, res) {
        // eslint-disable-line handle-callback-err
        dispatcher.emit("SHOW_FLASH_MESSAGE", {
          message: "An internal error occurred.",
          className: "warning"
        });
      }).onRedirect().handle(callback);
    }
  }]);

  return FormApiStorageProvider;
}(_BaseStorageProvider2.default);

exports.default = FormApiStorageProvider;